import type { ThemeConfig } from 'antd';
import { resolveThemeColor } from '@/utils/theme';

// Shared by the initial render and the existing brand-color picker.
export const buildAntdThemeConfig = (themeColor?: string): ThemeConfig => {
  const colorPrimary = resolveThemeColor(themeColor);

  return {
    cssVar: true,
    token: {
      fontFamily:
        'AlibabaSans, "PingFang SC", "Microsoft YaHei", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyCode:
        '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace',
      fontSize: 14,
      fontSizeHeading1: 28,
      fontSizeHeading2: 24,
      fontSizeHeading3: 20,
      fontSizeHeading4: 18,
      fontSizeHeading5: 16,
      lineHeight: 1.6,
      borderRadius: 6,
      borderRadiusLG: 10,
      borderRadiusSM: 4,
      controlHeight: 32,
      colorPrimary,
      colorInfo: '#2874ad',
      colorSuccess: '#16834a',
      colorWarning: '#a66b10',
      colorError: '#cf3544',
      colorText: '#283548',
      colorTextHeading: '#182638',
      colorTextSecondary: '#5e6d82',
      colorTextTertiary: '#68778b',
      colorBgLayout: '#f4f6f9',
      colorBgContainer: '#ffffff',
      colorBgElevated: '#ffffff',
      colorBorder: '#d8dfe8',
      colorBorderSecondary: '#e8ecf2',
      boxShadow: '0 8px 28px rgba(24, 38, 56, 0.10)',
      boxShadowSecondary: '0 4px 16px rgba(24, 38, 56, 0.08)',
    },
    components: {
      Button: {
        paddingInline: 14,
        fontWeight: 500,
        primaryShadow: 'none',
        defaultShadow: 'none',
      },
      Card: {
        headerHeight: 48,
        headerHeightSM: 40,
        headerFontSize: 16,
        bodyPadding: 20,
        bodyPaddingSM: 16,
        headerPadding: 20,
        headerPaddingSM: 16,
        boxShadowTertiary: '0 1px 3px rgba(24, 38, 56, 0.03)',
      },
      Table: {
        headerBg: '#f7f8fb',
        headerColor: '#4b5b70',
        headerSplitColor: 'transparent',
        rowHoverBg: `${colorPrimary}06`,
        rowSelectedBg: `${colorPrimary}0d`,
        borderColor: '#e8ecf2',
        cellPaddingBlock: 12,
        cellPaddingInline: 16,
        cellPaddingBlockMD: 10,
        cellPaddingInlineMD: 12,
        cellPaddingBlockSM: 8,
      },
      Menu: {
        itemBorderRadius: 6,
        itemHeight: 38,
        itemMarginBlock: 3,
        itemSelectedBg: `${colorPrimary}12`,
        itemHoverBg: `${colorPrimary}08`,
      },
      Form: { itemMarginBottom: 20, verticalLabelPadding: '0 0 6px' },
      Tabs: { horizontalMargin: '0 0 16px 0', titleFontSize: 14 },
      Statistic: { titleFontSize: 13, contentFontSize: 26 },
      Tag: { borderRadiusSM: 4 },
    },
  };
};
